// extracted by mini-css-extract-plugin
export default {"container":"CardDetails_container__BRZMF","box":"CardDetails_box__E7A0-","icon":"CardDetails_icon__8Oix2","icon_text_container":"CardDetails_icon_text_container__z5D+q"};